/**
 * Opens a product on its middle size instead of the smallest.
 * Shopify always preselects the first variant, and sizes are listed smallest first,
 * so without this every product would open on the smallest size.
 */
(() => {
  const PREFERRED_SIZES = ['m', 'medium'];

  // A shared or bookmarked link to a specific variant keeps that variant
  if (new URLSearchParams(window.location.search).has('variant')) return;

  customElements.whenDefined('variant-picker').then(() => {
    const picker = document.querySelector('main variant-picker');
    if (!picker) return;

    const input = Array.from(picker.querySelectorAll('input[type="radio"]')).find((radio) =>
      PREFERRED_SIZES.includes(radio.value.trim().toLowerCase())
    );
    if (!input || input.checked || input.dataset.optionAvailable === 'false') return;

    input.click();
  });
})();
